import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <SectionShell tone="darker" data-id="element-247" data-mp="2wzyv6qk4tooq">
      <SectionTitle eyebrow="📦 What’s inside" title="What’s inside the TRT Decision Deck™?" subtitle="6 premium volumes · 60+ decision cards · 30 clinical cases" data-id="element-248" data-mp="2x34hjy1dmcgr" />

      <div className="space-y-5" data-id="element-249" data-mp="2o2ep94bbr47s">
        {volumes.map(volume => <article key={volume.number} className="flex flex-col rounded-2xl border border-sky-400/20 bg-navy-900 p-5" data-id="element-250" data-mp="2j8aial226w6p">
            <span className="mb-2 self-start rounded-md bg-sky-400 px-2.5 py-1 font-display text-[11px] uppercase tracking-[0.15em] text-navy-950" data-id="element-251" data-mp="29byzdc7yr83a">
              {volume.number}
            </span>
            <h3 className="font-display text-xl leading-tight text-white sm:text-2xl" data-id="element-252" data-mp="20b9c4wwrqq16">
              {volume.title}
            </h3>
            <p className="mt-2 font-display text-xs uppercase leading-snug tracking-wide text-gold-400 sm:text-sm" data-id="element-253" data-mp="334uhpvtz4fu8">
              {volume.tagline}
            </p>
            <p className="mt-3 text-sm leading-relaxed text-sky-100/70" data-id="element-254" data-mp="2u57ss9ifl2i2">{volume.description}</p>

            <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.15em] text-sky-400" data-id="element-255" data-mp="2y69sssk69il3">
              {volume.listLabel}
            </p>
            <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-256" data-mp="3lxf4qwmzrqq4">
              {volume.items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-sky-100/85" data-id="element-257" data-mp="3quowiixuseh4">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-258" data-mp="3cuxk2mmzj658" />
                  <span data-id="element-259" data-mp="3hsz3x9s8j9hr">{item}</span>
                </li>)}
            </ul>

            {volume.note && <p className="mt-4 border-l-2 border-sky-400 pl-3 text-sm italic leading-relaxed text-sky-100/70" data-id="element-260" data-mp="21id6r85ytv2h">
                {volume.note}
              </p>}
          </article>)}
      </div>

      <div className="mt-8" data-id="element-261" data-mp="7022pp6ydguh">
        <CTAButton label="Get the complete TRT Decision Deck™" subline="6 volumes · 60+ cards · $27 one-time" data-id="element-262" data-mp="6zsd42ptlbpb" />
      </div>
    </SectionShell>;
}